export const CheckMarkIcon = () => {
    return (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.34663 8L0.5 4.2079L1.46166 3.25988L4.34663 6.10395L10.5383 0L11.5 0.948025L4.34663 8Z"
                  fill="white"/>
        </svg>
    );
};